import { baseUrl } from '../../../boot/index.js';
import axios from 'axios';
export const createSalesOrders = async (data) => {
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/create-salesorders`, data)
    console.log({ response })
    return response

  } catch (error) {
    console.log({ error })
  }
}

export const deleteSalesOrders = async (ROWID) => {
    console.log({ROWID})
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.delete(`${baseUrl}cleaningappfunctions/finance/app/v1/delete-salesorders/${ROWID}`, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      console.log("Error is - ",error)
      throw error
    }
  }

export const updateSalesOrders = async (data, id) => {
  console.log({ data })
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/finance/app/v1/update-salesorders/${id}`, data)
    console.log({ response })
    return response

  } catch (error) {
    console.log({ error })
  }
}





export const countSalesOrders = async (formData) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/getcount-salesorders`, formData, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      throw error
    }
  }



// Get SalesOrder By ID
export const getSalesOrderById = async (ROWID) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/getbyid-salesorders/${ROWID.id}`, {
      headers: {
        "auth-token": token,
      }
    },);
    console.log({ response })
    return response;
  } catch (error) {
    console.error('Error fetching Sales Order by id - ', error);
    throw error;
  }
}